// Exports
export default {
	"BroadcastViewerPlayer": "BroadcastViewerPlayer_KJiVu",
	"BroadcastViewerPlayer_hidden": "BroadcastViewerPlayer_hidden_0V4KL",
	"BroadcastViewerPlayer__Iframe": "BroadcastViewerPlayer__Iframe_yCQor"
};
